import * as v from 'valibot';

export const stringToBoolean = v.fallback(
  v.pipe(
    v.string(),
    v.transform(val => val === 'true'),
    v.boolean('string must be a valid boolean'),
  ),
  false,
);
